import React from 'react'
import PropTypes from 'prop-types'
import Wrapper from './src/components/Wrapper'

export const wrapPageElement = ({ element, props }) => {
  const theme = props.pageContext.customTheme
  return <Wrapper customTheme={theme}>{element}</Wrapper>
}

wrapPageElement.propTypes = {
  element: PropTypes.node.isRequired,
}
